module.exports = __webpack_public_path__ + "img/nato.aebe2fbc.svg";